import React from 'react';
import {Container, Row,Col} from "react-bootstrap";
import BgImg from "../../images/services-usa/game_update/workflow-bg.webp"
function Workflow(props) {
    return (
        <section className="workflow_section p-100"  style={{backgroundImage: `url(${BgImg})`}}>
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6}>
                        <h2>TekRevol’s Mobile Game App Development Workflow</h2>
                    </Col>
                    <Col xs={12} md={6} lg={6}>
                        <p>Our game app development process is a well-structured journey that begins with a thorough project scope determination early in the project life cycle.</p>
                    </Col>
                </Row>
                <Row className="workflow_max">
                    <Col>
                        <div className="workflow_listing">
                            <div className="workflow_items">
                                <h4><span>01</span>Plan</h4>
                                <p>We conduct concept analysis and research using client-provided details, formulating game design documents, flow design, and execution plans.</p>
                            </div>
                            <div className="workflow_items">
                                <h4><span>02</span>Concept Art</h4>
                                <p>Our team generates concept art and sketches aligned with the game's theme and vision.</p>
                            </div>
                            <div className="workflow_items">
                                <h4><span>03</span>Development</h4>
                                <p>Our game app developers transform the design into a high-quality game using top game engines and technologies.</p>
                            </div>
                            <div className="workflow_items">
                                <h4><span>04</span>Test</h4>
                                <p>Our experienced testers subject all games to rigorous QA and compatibility testing across various devices.</p>
                            </div>
                            <div className="workflow_items">
                                <h4><span>05</span>Launch</h4>
                                <p>Your mobile game app is ready to make its debut on various stores, reaching its intended audience.</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Workflow;